/**
 * Temps réel — ce que le serveur pousse au navigateur.
 *
 * Le CCT § 3.3 exige que les alertes, les statuts patients et le stock
 * arrivent poussés, pas interrogés en boucle. Une seule connexion par onglet
 * porte tous les canaux : ouvrir un socket par domaine multiplierait les
 * connexions par onze sites sans rien apporter.
 */
import { z } from 'zod';
/**
 * Les canaux poussés. Un par domaine qui change sous les yeux de quelqu'un.
 *
 * La liste grandira avec les modules — file d'attente en M1, stock en M2 —
 * et le front ignore poliment un canal qu'il ne connaît pas encore : un
 * serveur plus récent que l'onglet ouvert ne doit rien casser.
 */
export const CANAUX_TEMPS_REEL = [
    'notification',
    'file_attente',
    'eligibilite',
    /** La file « À confirmer » a bougé : une fiche y entre ou en sort (réunion du 15/10). */
    'a_confirmer',
    'caisse',
];
/**
 * Un message dit QUE quelque chose a changé, jamais QUOI.
 *
 * C'est délibéré, pour deux raisons :
 *
 *  - **Justesse.** Un émetteur peut écrire dans une transaction. Pousser le
 *    contenu avant le commit annoncerait une alerte qu'un retour arrière
 *    ferait disparaître ; le destinataire chercherait un problème qui
 *    n'existe pas. Un signal, lui, se corrige tout seul : la relecture ne
 *    trouve rien de neuf.
 *  - **Confidentialité.** Rien de nominatif ne transite par le socket. Ce
 *    que la personne lit ensuite passe par une route authentifiée, qui
 *    applique la portée habituelle.
 */
export const schemaMessageTempsReel = z.object({
    canal: z.enum(CANAUX_TEMPS_REEL),
});
/**
 * Le sous-protocole qui porte le jeton d'accès à l'ouverture.
 *
 * Un navigateur ne peut poser aucun en-tête sur une connexion WebSocket :
 * `new WebSocket(url, [SOUS_PROTOCOLE_JETON, jeton])` est le seul moyen
 * d'envoyer le jeton **hors de l'URL**. Le mettre en paramètre de requête le
 * ferait atterrir dans les journaux d'accès du reverse proxy, où il resterait
 * lisible et réutilisable pendant un quart d'heure.
 */
export const SOUS_PROTOCOLE_JETON = 'afs.jeton';
//# sourceMappingURL=temps-reel.js.map